import React from 'react'

const PageResults = () => {
  return (
    <div>PageResults</div>
  )
}

export default PageResults;